import Marionette from 'backbone.marionette';
import headlineTmpl from '../../common/templates/headline_itemview.tpl';
export default Marionette.ItemView.extend({
  template: headlineTmpl
});